import React, { memo } from 'react'
import styles from './styles.module.scss'

export function Image({ src, alt }: { src: string; alt: string }) {
  return <img className={styles.image} src={src} alt={alt} loading='lazy'></img>
}

export default memo(Image)
